import apiClient from './client';
import {
  AccountPerformanceResponse,
  BenchmarkResponse,
  CategoryAnalysisResponse,
  FunnelComparisonResponse,
  ScenarioAnalysisResponse,
  SegmentOverview,
} from '@/types/data';

export const segmentsApi = {
  // ファネル比較
  getFunnelComparison: async (params: {
    company_id: number;
    funnel_id_1: number;
    funnel_id_2: number;
    period_days?: number;
  }): Promise<FunnelComparisonResponse> => {
    const response = await apiClient.get('/api/segments/funnel-comparison', {
      params: {
        company_id: params.company_id,
        funnel_id_1: params.funnel_id_1,
        funnel_id_2: params.funnel_id_2,
        period_days: params.period_days ?? 30,
      },
    });
    return response.data;
  },

  // アカウント別パフォーマンス
  getAccountPerformance: async (params: {
    company_id: number;
    period_days?: number;
  }): Promise<AccountPerformanceResponse> => {
    const response = await apiClient.get('/api/segments/accounts', {
      params: {
        company_id: params.company_id,
        period_days: params.period_days ?? 30,
      },
    });
    return response.data;
  },

  // カテゴリ別分析
  getCategoryAnalysis: async (params: {
    company_id: number;
    period_days?: number;
  }): Promise<CategoryAnalysisResponse> => {
    const response = await apiClient.get('/api/segments/categories', {
      params: {
        company_id: params.company_id,
        period_days: params.period_days ?? 30,
      },
    });
    return response.data;
  },

  // シナリオ別分析
  getScenarioAnalysis: async (params: {
    company_id: number;
    period_days?: number;
  }): Promise<ScenarioAnalysisResponse> => {
    const response = await apiClient.get('/api/segments/scenarios', {
      params: {
        company_id: params.company_id,
        period_days: params.period_days ?? 30,
      },
    });
    return response.data;
  },

  // ベンチマーク比較
  getBenchmarkComparison: async (params: {
    company_id: number;
    period_days?: number;
  }): Promise<BenchmarkResponse> => {
    const response = await apiClient.get('/api/segments/benchmarks', {
      params: {
        company_id: params.company_id,
        period_days: params.period_days ?? 30,
      },
    });
    return response.data;
  },

  // セグメント概要
  getOverview: async (params: {
    company_id: number;
    period_days?: number;
  }): Promise<SegmentOverview> => {
    const response = await apiClient.get('/api/segments/overview', {
      params: {
        company_id: params.company_id,
        period_days: params.period_days ?? 30,
      },
    });
    return response.data;
  },
};
